"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconSearch', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M14.77,13.67l-4-4a5.47,5.47,0,1,0-1.1,1.1l4,4a.77.77,0,0,0,1.1,0A.77.77,0,0,0,14.77,13.67ZM2.56,6.44a3.89,3.89,0,1,1,3.88,3.89A3.88,3.88,0,0,1,2.56,6.44Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M3,8 C3,5.243 5.243,3 8,3 C10.757,3 13,5.243 13,8 C13,10.757 10.757,13 8,13 C5.243,13 3,10.757 3,8 M18.707,17.293 L13.599,12.185 C14.475,11.016 15,9.569 15,8 C15,4.141 11.859,1 8,1 C4.141,1 1,4.141 1,8 C1,11.859 4.141,15 8,15 C9.569,15 11.016,14.475 12.185,13.599 L17.293,18.707 C17.488,18.902 17.744,19 18,19 C18.256,19 18.512,18.902 18.707,18.707 C19.098,18.316 19.098,17.684 18.707,17.293'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _SVGIconWithSizes)));

exports.default = _default;